import React from "react";
import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import GoldDivider from "../components/GoldDivider";
import { services } from "../data/services";
import { ArrowRight } from "lucide-react";

const Services = () => (
    <div data-testid="page-services">
        <section className="relative pt-44 pb-24">
            <div className="max-w-5xl mx-auto px-6 text-center">
                <Reveal>
                    <p className="text-[0.7rem] tracking-[0.55em] uppercase text-brand-gold mb-6">Capabilities</p>
                    <h1 className="font-serif-editorial text-5xl md:text-6xl lg:text-7xl text-brand-silver leading-[1.05]">
                        The <span className="italic text-brand-champagne">administration</span> of wealth
                        through real property.
                    </h1>
                    <p className="mt-10 text-brand-silver/75 max-w-2xl mx-auto leading-relaxed text-lg">
                        Our mandate extends beyond the transaction. From first introduction to
                        generational stewardship, we handle the entirety of a real-estate life cycle.
                    </p>
                </Reveal>
            </div>
        </section>

        <section className="pb-24">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-brand-gold/10 border border-brand-gold/10">
                    {services.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <Reveal key={s.id} delay={i * 90} className="bg-brand-jet">
                                <div className="p-10 lg:p-12 h-full group hover:bg-brand-onyx transition-colors duration-500">
                                    <Icon size={32} strokeWidth={1} className="text-brand-gold" />
                                    <h3 className="mt-6 font-serif-editorial text-2xl text-brand-silver group-hover:text-brand-champagne transition">
                                        {s.name}
                                    </h3>
                                    <p className="mt-4 text-sm text-brand-silver/65 leading-relaxed">{s.blurb}</p>
                                    <div className="mt-8 text-[0.65rem] tracking-[0.4em] uppercase text-brand-gold/70">
                                        0{i + 1} · Service
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>

        <GoldDivider />

        <section className="py-28 md:py-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <Reveal>
                    <h2 className="font-serif-editorial text-3xl md:text-5xl text-brand-silver mb-16 text-center">
                        The Process
                    </h2>
                </Reveal>
                <div className="grid md:grid-cols-4 gap-px bg-brand-gold/10 border border-brand-gold/10">
                    {[
                        { n: "I", t: "Introduction", d: "Private inquiry, scope, and confidentiality." },
                        { n: "II", t: "Strategy", d: "Underwriting, positioning, and capital alignment." },
                        { n: "III", t: "Execution", d: "Discreet negotiation and diligence to close." },
                        { n: "IV", t: "Administration", d: "Post-close stewardship and concierge." },
                    ].map((step, i) => (
                        <Reveal key={step.n} delay={i * 100} className="bg-brand-jet">
                            <div className="p-10 lg:p-12 h-full">
                                <div className="font-cursive text-5xl text-brand-gold wordmark-glow leading-none">
                                    {step.n}
                                </div>
                                <h3 className="mt-6 font-serif-editorial text-xl text-brand-champagne">{step.t}</h3>
                                <p className="mt-3 text-sm text-brand-silver/65 leading-relaxed">{step.d}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>

        <section className="pb-32 text-center max-w-3xl mx-auto px-6">
            <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-xs tracking-[0.35em] uppercase border border-brand-gold text-brand-gold px-10 py-5 hover:bg-brand-gold hover:text-brand-jet transition-all duration-500"
                data-testid="services-cta-contact"
            >
                Engage The Firm <ArrowRight size={14} />
            </Link>
        </section>
    </div>
);

export default Services;
